import { SUPPORT_URL_REQUEST_TYPE } from '@/shared/config';
import { t } from 'ttag';

const CATEGORY_LIST = [
  {
    label: t`Change study type`,
    value: SUPPORT_URL_REQUEST_TYPE.changeStudyType,
  },
  {
    label: t`Abort study`,
    value: SUPPORT_URL_REQUEST_TYPE.abortStudy,
  },
  {
    label: t`Change study information`,
    value: SUPPORT_URL_REQUEST_TYPE.changeStudyInformation,
  },
  {
    label: t`Report request`,
    value: SUPPORT_URL_REQUEST_TYPE.reportRequest,
  },
  {
    label: t`Web portal issues`,
    value: SUPPORT_URL_REQUEST_TYPE.webPortalIssues,
  },
  {
    label: t`Billing questions`,
    value: SUPPORT_URL_REQUEST_TYPE.billingQuestions,
  },
  {
    label: t`Others`,
    value: SUPPORT_URL_REQUEST_TYPE.others,
  },
];

const OBJECT_CATEGORY_LIST = {
  [SUPPORT_URL_REQUEST_TYPE.changeStudyType]: 'ChangeStudyType',
  [SUPPORT_URL_REQUEST_TYPE.abortStudy]: 'AbortStudy',
  [SUPPORT_URL_REQUEST_TYPE.reportRequest]: 'ReportRequest',
  [SUPPORT_URL_REQUEST_TYPE.changeStudyInformation]: 'ChangeStudyInformation',
  [SUPPORT_URL_REQUEST_TYPE.webPortalIssues]: 'WebPortalIssues',
  [SUPPORT_URL_REQUEST_TYPE.billingQuestions]: 'BillingQuestions',
  [SUPPORT_URL_REQUEST_TYPE.others]: 'Other',
};

export { CATEGORY_LIST, OBJECT_CATEGORY_LIST };
